<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["SEO"][obj_as.I > 0? "ESEO": "ASEO"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="6" v-if="getUserInfo.AT !== 4">
                                            <label class="col-form-label-sm">{{this.getLanguage["SEO"]["BN"]}}<span class="required" /> :</label>
                                            <customtreeselect :multiple="false"
                                                        :options="dd_agentgroup"
                                                        :flat="true"
                                                        :defaultExpandLevel="Infinity"
                                                        :clearable="false"
                                                        :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                        v-model="obj_as['AGIT']"
                                                        @input="AgentGroupChange"
                                                        :disabled="obj_as.I > 0"
                                                        ref="AGIT" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('AGIT','BN') }}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["GL"]["SAGT"]}} :</label>
                                            <treeselect :multiple="false"
                                                        :async="true"
                                                        :key="rtSubBrand"
                                                        :load-options="loadSubBrandOptions"
                                                        :cacheOptions="false"
                                                        :options="dd_subagentgroup"
                                                        :defaultOptions="dd_DefaultSubBrand"
                                                        :disable-branch-nodes="true"
                                                        :searchPromptText="this.getLanguage['GL']['DDTS']"
                                                        :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                                        :noResultsText="this.getLanguage['GL']['NRF']"
                                                        v-model="obj_as['SAGAGI']"
                                                        @input="SubAgentGroupChange"
                                                        openDirection="below"
                                                        :disabled="obj_as.I > 0" />
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6" v-if="this.obj_as.AT != 0">
                                            <label class="col-form-label-sm">{{this.getLanguage["SEO"]["DN"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_do"
                                                        :placeholder="this.utilGetDDLanguage('SEO.DN')"
                                                        :noOptionsText="this.getLanguage['GL']['NOA']"
                                                        @input="DomainChange"
                                                        v-model="obj_as['DIT']"
                                                        :disabled="obj_as.I > 0" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('DIT','DN') }}</span>
                                        </CCol>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["SEO"]["L"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_lang"
                                                        :placeholder="this.utilGetDDLanguage('SEO.L')"
                                                        :noOptionsText="this.getLanguage['GL']['NOA']"
                                                        v-model="obj_as['L']"
                                                        :limit="1"
                                                        :limitText="count => `+${count}`"
                                                        :disabled="obj_as.I > 0"
                                                        ref="L">
                                                <div slot="value-label" slot-scope="{ node }">
                                                    <span v-for="(data,index) in dd_lang" v-if="node.id==data.id" class="flagClass" :class="setFlag(data.id)"></span>
                                                    <span>{{ node.label }}</span>
                                                </div>
                                                <div slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName }" :class="labelClassName">
                                                    <span v-for="(data,index) in dd_lang" v-if="node.id==data.id" class="flagClass" :class="setFlag(data.id)"></span>
                                                    <span>{{ node.label }}</span>
                                                </div>
                                            </treeselect>
                                            <span class="ErrMsg">{{ ValidationErrMsg('L','L') }}</span>
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="6" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["SEO"]["PT"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_pt"
                                                        :placeholder="this.utilGetDDLanguage('SEO.PT')"
                                                        v-model="obj_as['PT']"
                                                        @input="PageTypeChange"
                                                        :disabled="obj_as.I > 0"
                                                        ref="PT" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('PT','PT') }}</span>
                                        </CCol>
                                        <CCol col="6" v-if="obj_as['PT'] == 0">
                                            <label class="col-form-label-sm">{{this.getLanguage["SEO"]["PGT"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_spt"
                                                        :placeholder="this.utilGetDDLanguage('SEO.PGT')"
                                                        v-model="obj_as['PGTS']"
                                                        @input="ClearDD"
                                                        :disabled="obj_as.I > 0"
                                                        ref="PGTS" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('PGTS','PGT') }}</span>
                                        </CCol>
                                        <CCol col="6" v-if="obj_as['PT'] == null || obj_as['PT'] == 1">
                                            <label class="col-form-label-sm">{{this.getLanguage["SEO"]["PGT"]}}<span class="required" /> :</label>
                                            <span class="WCMsg" v-if="this.obj_as.PGTS != null">{{ this.obj_as.PGTS.length }} / 100 </span>
                                            <span class="WCMsg" v-else> 0 / 100 </span>
                                            <CInput maxlength="100"
                                                    size="sm"
                                                    :value="obj_as.PGTS"
                                                    @change="pageTitleChanged($event)"
                                                    ref="PGTS" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('PGTS','PGT') }}</span>
                                        </CCol>
                                        <!-- Static Page Page Title -->
                                        <CCol col="6" v-if="obj_as['PT'] == 2">
                                            <label class="col-form-label-sm">
                                                {{this.getLanguage["SEO"]["PGT"]}}<span class="required" /> :
                                                <div v-if="getUserInfo.AT == 0 && obj_as.AT == 0 && obj_as.PGTS == 2 && obj_as.PT == 2" class="custom_tooltip">
                                                    <input type="checkbox" v-model="obj_as.FD"> {{this.getLanguage["SEO"]["FD"]}}
                                                </div>
                                            </label>
                                            <treeselect :multiple="false"
                                                        :options="dd_stapt"
                                                        :placeholder="this.utilGetDDLanguage('SEO.PGT')"
                                                        @input="ClearBT"
                                                        v-model="obj_as['PGTS']"
                                                        :disabled="obj_as.I > 0"
                                                        ref="PGTS" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('PGTS','PGT') }}</span>
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="6">
                                            <div v-if="obj_as.PGTS == 103">
                                                <label class="col-form-label-sm">{{this.getLanguage["SEO"]["PRVD"]}} :</label>
                                                <treeselect v-if="obj_as.PGTS == 103"
                                                            :multiple="false"
                                                            :load-options="loadProviderOptions"
                                                            :options="dd_gp"
                                                            :placeholder="this.getLanguage['SEO']['PRVD']"
                                                            @input="ProviderChange"
                                                            v-model="obj_as['GPRVD']"
                                                            :disabled="obj_as['PT'] != 0 || obj_as.I > 0 || obj_as.PGTS != 103"
                                                            ref="GPRVD" />
                                                <span class="ErrMsg">{{ ValidationErrMsg('GPRVD','PRVD') }}</span>
                                            </div>
                                            <div col="6" v-if="obj_as.PGTS == 2 && obj_as.PT == 2">
                                                <label class="col-form-label-sm">{{this.getLanguage["SEO"]["BT"]}}<span class="required" /> :</label>
                                                <CInput size="sm"
                                                        :value="obj_as.BT"
                                                        @change="pageBTitleChanged($event)"
                                                        :placeholder="this.getLanguage['SEO']['BT']"
                                                        ref="BT" />
                                                <span class="ErrMsg">{{ ValidationErrMsg('BT','BT') }}</span>
                                            </div>
                                        </CCol>

                                        <CCol col="6" v-if="this.obj_as.AT != 0">
                                            <label v-if="pageUrlAllow" class="col-form-label-sm">{{this.getLanguage["SEO"]["PURL"]}}<span class="required" /> :</label>
                                            <CInput v-if="pageUrlAllow"
                                                    size="sm"
                                                    :value="pageURL"
                                                    @change="verifyPageUrl($event)"
                                                    :disabled="obj_as['PT'] != 1 || obj_as['PT'] != 0"
                                                    ref="PURL" />
                                            <span v-if="pageUrlAllow">{{pageURL}}</span>
                                            <span class="ErrMsg">{{ ValidationErrMsg('PURL','PURL') }}</span>
                                        </CCol>

                                        <CCol col="6" v-else-if="getUserInfo.AT == 0 && obj_as.AT == 0 && obj_as.PGTS == 2 && obj_as.PT == 2 && obj_as.FD">
                                            <label class="col-form-label-sm">{{this.getLanguage["SEO"]["EXCB"]}}:</label>
                                            <treeselect :multiple="true"
                                                        :options="dd_exclude_agentgroup"
                                                        :defaultExpandLevel="Infinity"
                                                        :clearable="true"
                                                        :placeholder="this.utilGetDDLanguage('SEO.EXCB')"
                                                        v-model="arr_excludeBrand"
                                                        valueConsistsOf="LEAF_PRIORITY"
                                                        :limit="1"
                                                        :limitText="count => `+${count}`"
                                                        ref="EXCB" />
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["SEO"]["MT"]}}<span class="required" /> :</label>
                                            <span class="WCMsg" v-if="this.obj_as.MT != null">{{ this.obj_as.MT.length }} / 100 </span>
                                            <span class="WCMsg" v-else> 0 / 100 </span>
                                            <CInput maxlength="100" size="sm"
                                                    :value="obj_as.MT"
                                                    @change="v => obj_as.MT = v"
                                                    ref="MT" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('MT','MT') }}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <div style="margin-bottom:20px" v-if="obj_as['PT'] == 2">
                                                <label class="col-form-label-sm">{{getLanguage["SEO"]["DS"]}} :</label><br>
                                                <label class="switch">
                                                    <input type="checkbox"
                                                           :disabled="obj_as['PT'] != 2"
                                                           :checked="obj_as['RS']"
                                                           @change="v => obj_as['RS'] = v.target.checked">
                                                    <span class="slider round"></span>
                                                </label>
                                            </div>
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["SEO"]["MR"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="true"
                                                        :options="dd_mr"
                                                        :placeholder="this.utilGetDDLanguage('SEO.MR')"
                                                        v-model="obj_as['MetaRobot']"
                                                        :limit="1"
                                                        :limitText="count => `+${count}`"
                                                        ref="MetaRobot" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('MetaRobot','MR') }}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["SEO"]["MK"]}}<span class="required" /> :</label>
                                            <span class="WCMsg" v-if="this.obj_as.MK != null">{{ this.obj_as.MK.length }} / 200 </span>
                                            <span class="WCMsg" v-else> 0 / 200 </span>
                                            <CInput maxlength="200"
                                                    size="sm"
                                                    :value="obj_as.MK"
                                                    @change="v => obj_as.MK = v"
                                                    ref="MK" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('MK','MK') }}</span>
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["SEO"]["MD"]}}<span class="required" /> :</label>
                                            <span class="WCMsg" v-if="this.obj_as.MD != null">{{ this.obj_as.MD.length }} / 200 </span>
                                            <span class="WCMsg" v-else> 0 / 200 </span>
                                            <textarea maxlength="200"
                                                      vertical=""
                                                      rows="6"
                                                      class="form-control form-control-sm"
                                                      @change="TextValueChange('MD',$event)"
                                                      :value="obj_as.MD"
                                                      v-shortkey.avoid
                                                      ref="MD" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('MD','MD') }}</span>
                                        </CCol>

                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["SEO"]["SD"]}} :</label>
                                            <textarea vertical="" rows="6" class="form-control form-control-sm" :value="obj_as.SD" @change="TextValueChange('SD',$event)" v-shortkey.avoid />
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["SEO"]["HS"]}} :</label>
                                            <span class="ErrMsg">{{this.getLanguage["SEO"]["WRN"]}}</span>
                                            <textarea vertical="" rows="6" class="form-control form-control-sm" :value="obj_as.HS" @change="TextValueChange('HS',$event)" v-shortkey.avoid />
                                            <label class="col-form-label-sm">{{this.getLanguage["SEO"]["HSD"]}}</label>
                                        </CCol>

                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["SEO"]["FS"]}} :</label>
                                            <span class="ErrMsg">{{this.getLanguage["SEO"]["WRN"]}}</span>
                                            <textarea vertical="" rows="6" class="form-control form-control-sm" :value="obj_as.FS" @change="TextValueChange('FS',$event)" v-shortkey.avoid />
                                            <label class="col-form-label-sm">{{this.getLanguage["SEO"]["FSD"]}}</label>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["SEO"]["OT"]}} :</label>
                                            <span class="WCMsg" v-if="this.obj_as.OT != null">{{ this.obj_as.OT.length }} / 100 </span>
                                            <span class="WCMsg" v-else> 0 / 100 </span>
                                            <CInput maxlength="100" size="sm"
                                                    :value="obj_as.OT"
                                                    @change="v => obj_as.OT = v" />
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["SEO"]["OTP"]}} :</label>
                                            <span class="WCMsg" v-if="this.obj_as.OTP != null">{{ this.obj_as.OTP.length }} / 100 </span>
                                            <span class="WCMsg" v-else> 0 / 100 </span>
                                            <CInput maxlength="100" size="sm" v-model="obj_as.OTP" />
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["SEO"]["OD"]}} :</label>
                                            <span class="WCMsg" v-if="this.obj_as.OD != null">{{ this.obj_as.OD.length }} / 200 </span>
                                            <span class="WCMsg" v-else> 0 / 200 </span>
                                            <textarea maxlength="200" vertical="" rows="6" class="form-control form-control-sm" v-model="obj_as.OD"></textarea>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["SEO"]["OI"]}}({{getLanguage["PM"]["SQR"]}}-<span style="color:red">500 X 500</span>) :</label>
                                            <CTabs variant='tabs' id="imageURLTab2">
                                                <CTab :title="getLanguage['CTAB']['UI']" :active="obj_as.PMIUT === false ? true: false">
                                                    <img v-if="obj_as['OI'] !=null"
                                                         width="auto"
                                                         height="150"
                                                         class="mb-2"
                                                         :src="getImgUrl(obj_as['OI'])" />
                                                    <div class="custom-file">
                                                        <input type="file" class="custom-file-input" id="validatedCustomFile" name="pic" accept="image/*" @change="onPMIUFileSelected" required>
                                                        <label class="custom-file-label" for="validatedCustomFile" v-if="NewPMIUFile === null">{{ getLanguage['CTAB']['CAI'] }}</label>
                                                        <label class="custom-file-label" for="validatedCustomFile" v-else>{{NewPMIUFile.name}}</label>
                                                        <div class="invalid-feedback">{{ getLanguage['ERR']['8007'] }}</div>
                                                    </div>
                                                </CTab>
                                                <CTab :title="getLanguage['CTAB']['U']" :active="obj_as.PMIUT === true ? true: false">
                                                    <img v-if="obj_as['OI'] !=null"
                                                         width="auto"
                                                         height="130"
                                                         class="mb-2"
                                                         :src="getImgUrl(obj_as['OI'])" />
                                                    <label class="sr-only" for="inlineFormInputGroupUsername">{{ getLanguage['CTAB']['U'] }}</label>
                                                    <div class="input-group">
                                                        <div class="input-group-prepend">
                                                            <div class="input-group-text">{{ getLanguage['CTAB']['U'] }}</div>
                                                        </div>
                                                        <input type="url" class="form-control" :placeholder="getLanguage['CTAB']['U']" v-model="obj_as.OI">
                                                    </div>
                                                </CTab>
                                            </CTabs>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12">
                                            <label class="col-form-label-sm">{{this.getLanguage["SEO"]["AC"]}} :</label>
                                            <editor id="htmluuid" @onChange="HTMLEditorTextChange" :value="obj_as.AC" :init="init" />
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton :disabled="sensBtn" color="outline-info" size="sm" @click="saveSEO()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["SEO"]["SEO"]}}</h2>
                        <CButton size="sm" v-if="checkModuleAccess2(constAccessType.add)" color="outline-info" @click="addSEO()"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4">
                                <span class='searchLabel'>{{this.getLanguage["SEO"]["BN"]}} :</span>
                                <customtreeselect :multiple="false"
                                            :options="dd_agentgroupfs"
                                            :flat="true"
                                            :defaultExpandLevel="Infinity"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SAGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :defaultOptions="dd_DefaultSubBrand"
                                            :options="dd_subagentgroup"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            :noResultsText="this.getLanguage['GL']['NRF']"
                                            v-model="str_FV[6].FV"
                                            openDirection="below"
                                            @input="SubAgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["SEO"]["PT"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_pt"
                                            :placeholder="this.utilGetDDLanguage('SEO.PT')"
                                            v-model="str_FV[0].FV" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="str_FV[3].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[3].FV.startDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[3].FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="str_FV[3].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[3].FV.endDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[3].FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["SEO"]["DN"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_dofs"
                                            :placeholder="this.utilGetDDLanguage('SEO.DN')"
                                            :noOptionsText="this.getLanguage['GL']['NOA']"
                                            v-model="str_FV[2].FV" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["SEO"]["L"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_langfs"
                                            :placeholder="this.utilGetDDLanguage('SEO.L')"
                                            v-model="str_FV[4].FV"
                                            :limit="1"
                                            :limitText="count => `+${count}`">
                                    <div slot="value-label" slot-scope="{ node }">
                                        <span v-for="(data,index) in dd_langfs" v-if="node.id==data.id" class="flagClass" :class="setFlag(data.id)"></span>
                                        <span>{{ node.label }}</span>
                                    </div>
                                    <div slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName }" :class="labelClassName">
                                        <span v-for="(data,index) in dd_langfs" v-if="node.id==data.id" class="flagClass" :class="setFlag(data.id)"></span>
                                        <span>{{ node.label }}</span>
                                    </div>
                                </treeselect>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["SEO"]["MR"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_mr"
                                            :placeholder="this.utilGetDDLanguage('SEO.MR')"
                                            v-model="str_FV[5].FV"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-hotkey="keymap" class='searchBtn' ref="search" size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>


            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage["SEO"]["SEOL"]}}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th>{{this.getLanguage["SEO"]["DN"]}}<i @click="setSortTable('DN')" :class="setSortLogo('DN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["SEO"]["L"]}}<i @click="setSortTable('L')" :class="setSortLogo('L')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["SEO"]["MT"]}}<i @click="setSortTable('MT')" :class="setSortLogo('MT')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["SEO"]["PT"]}}<i @click="setSortTable('PT')" :class="setSortLogo('PT')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["SEO"]["PGT"]}}<i @click="setSortTable('PGT')" :class="setSortLogo('PGT')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["SEO"]["PURL"]}}<i @click="setSortTable('PURL')" :class="setSortLogo('PURL')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["GL"]["CB"]}}<i @click="setSortTable('CB')" :class="setSortLogo('CB')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["GL"]["CT"]}}<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["GL"]["UB"]}}<i @click="setSortTable('UB')" :class="setSortLogo('UB')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["GL"]["UTS"]}}<i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th>{{this.getLanguage["SEO"]["DN"]}}<i @click="setSortTable('DN')" :class="setSortLogo('DN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["SEO"]["L"]}}<i @click="setSortTable('L')" :class="setSortLogo('L')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["SEO"]["MT"]}}<i @click="setSortTable('MT')" :class="setSortLogo('MT')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["SEO"]["PT"]}}<i @click="setSortTable('PT')" :class="setSortLogo('PT')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["SEO"]["PGT"]}}<i @click="setSortTable('PGT')" :class="setSortLogo('PGT')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["SEO"]["PURL"]}}<i @click="setSortTable('PURL')" :class="setSortLogo('PURL')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["GL"]["CB"]}}<i @click="setSortTable('CB')" :class="setSortLogo('CB')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["GL"]["CT"]}}<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["GL"]["UB"]}}<i @click="setSortTable('UB')" :class="setSortLogo('UB')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["GL"]["UTS"]}}<i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_sl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_sl">
                            <td>{{ CountItem(index+1) }}</td>
                            <td v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">
                                <span id="actionBtnCol">
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" style="display: block;">
                                        <i class="cil-trash" @click="removeSEO(data)"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AAGI == curAGI && data.AGI != curAGI)" style="display: block;">
                                        <i class="cil-trash" @click="removeSEO(data)"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI && data.AAGI != curAGI)" style="display: block;">
                                        <i class="cil-trash"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" style="display: block;">
                                        <i class="cil-color-border" @click="editSEO(data.I)"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AAGI == curAGI && data.AGI != curAGI)" style="display: block;">
                                        <i class="cil-color-border" @click="editSEO(data.I)"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI && data.AAGI != curAGI)" style="display: block;">
                                        <i class="cil-color-border"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                </span>
                            </td>
                            <td>
                                <span v-if="data.DI != 0">{{ data.DN }}</span>
                                <span v-else>-</span>
                            </td>
                            <td><span class="grid-line" v-for="lang in data.Languages">{{ lang }}</span></td>
                            <td>{{ data.MT }}</td>
                            <td>{{ ConvertPageType(data.PT) }}</td>
                            <td>{{ substrContent(data.PGT,50) }} {{ data.BT ? '- ' + substrContent(data.MT,50) : '' }}{{ ConvertPageTitle(data.PRVD) }}</td>
                            <td>
                                <span v-if="data.DI != 0 && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" v-html="formatURL(data)"></span>
                                <span v-if="data.DI != 0 && (isSENS == 1 && data.AAGI == curAGI && data.AGI != curAGI)" v-html="formatURL(data)"></span>
                                <span v-if="data.DI != 0 && (isSENS == 1 && data.AGI != curAGI && data.AAGI != curAGI)">-</span>
                            </td>
                            <td>{{ data.CB }}</td>
                            <td>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td>{{ data.UB }}</td>
                            <td>{{ formatDateTime(data.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import { required, requiredIf } from 'vuelidate/lib/validators'
    import genericHelper from "@/modules/GenericHelper.js";
    import { constAccessType, consMetaRobot, constImgURClientId, loadingFullScreen } from '@/modules/Constant.js'
    import axios from "axios";
    import moment from "moment";
    import Vue from 'vue'
    import VueHotkey from 'v-hotkey'
    import Axios from 'axios';
    import Editor from '@tinymce/tinymce-vue'
    import $ from 'jquery'

    //Vue.use(require('vue-shortkey'))
    Vue.use(VueHotkey)

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            'editor': Editor,
        },
        props: {

        },
        data() {
            return {
                bool_CV: false, // Check Validation
                bool_isAMV: false, // Add Modal Visible
                bool_fullLoading: false, //Loading Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                int_TI: 0,//Total Items
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true,
                str_FV: [{ F: "PT" }, { F: "AGI" }, { F: "DIT" }, { F: "CTS", FV: { startDate: "", endDate: "" } }, { F: "L_csv", FA: true }, { F: "MR_csv", FA: true }, { F: "SAGAGI" }], //Filter Value
                arry_sl: [], //seo list
                obj_as: {
                    I: 0,
                    RS: true,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    DN: null,
                    DI: null,
                    DAI: null,
                    DIT: null,
                    L: null,
                    PT: null,
                    FD: null,
                    PGT: null,
                    PGTS: null,
                    PURL: null,
                    PRVD: null,
                    GPRVD: null,
                    BT: null,
                    MT: null,
                    MK: null,
                    MR: [],
                    MetaRobot: null,
                    MD: null,
                    SD: null,
                    AC: "",
                    AGI: "",
                    SAGAGI: null,
                    AGIT: null,
                    AT: 3,
                    HS: null,
                    FS: null,
                    editorText: "",
                    PMIUT: false,
                    OI: "",
                    OT: null,
                    OTP: null,
                    OD: null,
                    EXCB : null
                }, // add seo
                editorText: "",
                //dd_pt: [{ id: '0', label: 'System Page' }, { id: '1', label: 'Custom Page' }, { id: '2', label: 'Static Page' }], // page type
                dd_pt: [],
                dd_spt: [], //System Page Type
                dd_stapt: [{ id: '0', label: 'Contact Us' }, { id: '1', label: 'About Us' }, { id: '2', label: 'FAQ' }, { id: '3', label: 'How To Register' }, { id: '4', label: "Terms Of Use" }, { id: '5', label: 'Blog' }, { id: '6', label: 'Referral' }], //Static Page Type
                dd_mr: [], //mata robot
                dd_do: [], // Domain Option
                dd_dofs: [], // Domain Option for search
                dd_lang: [],//language option
                dd_langfs: [],//language option
                dd_gameprovider: [],
                constAccessType: constAccessType,
                dd_agentgroup: [],//agent group option
                dd_exclude_agentgroup: [],
                dd_agentgroupfs: [],//agent group option
                dd_subagentgroup: [], //subagent group option
                dd_DefaultSubBrand: [],
                rtSubBrand: 0,
                dd_gp: null,
                pageUrlAllow: false,
                domainUrl: null,
                NewPMIUFile: null,
                sensBtn: false,
                excludeId: ['0', '100', '101', '102', '103', '104', '105', '106', '107', '108', '109', '110'],
                init: {
                    height: 500,
                    plugins: [
                        'lists advlist',
                        'image imagetools',
                        'link autolink',
                        'table',
                        'charmap',
                        'searchreplace visualblocks code fullscreen',
                        'print preview anchor insertdatetime',
                        'help codesample hr pagebreak nonbreaking toc textpattern noneditable',
                        'importcss',
                        'directionality',
                        'visualchars',
                        'emoticons',
                        'autosave',
                        'wordcount'
                    ],
                    toolbar:
                        'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',
                    branding: false,
                    menubar: true,
                    file_picker_callback: function (cb) {
                        var input = document.createElement('input');
                        input.setAttribute('type', 'file');
                        input.setAttribute('accept', 'image/*');

                        input.onchange = function () {
                            this.bool_fullLoading = true;
                            var file = this.files[0];
                            var reader = new FileReader();

                            if (!file) {
                                return;
                            }
                            if (!file.name.match(/\.(jpg|jpeg|png)$/)) {
                                return;
                            }

                            reader.onload = function () {
                                var that = this;
                                var formData = new FormData();
                                formData.append('image', file)

                                Axios({
                                    url: 'https://api.imgur.com/3/image',
                                    method: 'POST',
                                    headers: {
                                        'Authorization': 'Client-ID ' + constImgURClientId
                                    },
                                    data: formData
                                })
                                    .then((result) => {
                                        let url = result.data.data.link;
                                        that.bool_fullLoading = true;
                                        cb(url, { title: file.name });
                                    })
                                    .catch((err) => {
                                        that.bool_fullLoading = true;
                                    });
                            };
                            reader.readAsDataURL(file);
                        };
                        input.click();
                    }
                },
                arr_excludeBrand: null
            }
        },
        validations: {
            obj_as: {
                AGIT: { required },
                DIT: {
                    required: requiredIf(function (vm) {
                        this.obj_as.AT != 0
                    }),
                },
                L: { required },
                PT: { required },
                BT: {
                    required: requiredIf(function (vm) {
                        return vm.PT == 2 && vm.PGTS == 2
                    }),
                },
                PGTS: { required },
                PURL: {
                    required: requiredIf(function (vm) {
                        return (vm.PT == 1 || vm.PT == 2) && this.obj_as.AT != 0;
                    }),
                },
                MT: { required },
                MetaRobot: { required },
                MK: { required },
                MD: { required },
                GPRVD: {
                    required: requiredIf(function (vm) {
                        return vm.PT == 0 && vm.PGTS == 103;
                    }),
                },
            }
        },
        created() {
            this.$parent.showSubMenu = 'MS';
            this.$parent.showActiveMenu = 'MS.S';
            this.getLangauge();
            this.getPageType();
            this.getMetaRobot();
            this.getAgentGroup();
            this.getGameProvider();
            this.isSENS = this.getUserInfo.ISENS;            
            this.curAGI = this.getUserInfo.AGI;            
            //this.subAGI = this.getUserInfo.AGIBYPGI;

            if (this.getUserInfo.AT == 4) {
                this.getSubAgentGroup(0, true);
            } else {
                this.getSEOList();
            }
            this.getPType();
        },
        computed: {
            keymap() {
                return {
                    'enter': {
                        keydown: this.newSearch,
                        keyup: null
                    }
                }
            },
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
            pageURL: {
                get() {
                    if (this.obj_as['PGTS'] != null) {
                        if (this.obj_as.PT == 0) {
                            for (var pt of this.dd_spt) {
                                if (pt.id == this.obj_as['PGTS'] && this.obj_as['I'] == 0 && this.obj_as.PGTS != 103) {
                                    this.obj_as['MT'] = pt.label;
                                }
                            }
                        }
                        else if (this.obj_as.PT == 2) {
                            for (var pt of this.dd_stapt) {
                                if (pt.id == this.obj_as['PGTS'] && this.obj_as['I'] == 0) {
                                    this.obj_as['MT'] = pt.label;
                                }
                            }
                        }
                    }
                    if (this.obj_as['DIT'] != null && this.obj_as['PGTS'] == null) {
                        var domain = this.obj_as['DIT'].split("-");
                        var mainDomain = domain[0] + "-0";
                        for (var d of this.dd_do) {
                            if (d.id == mainDomain) {
                                this.obj_as['DN'] = d.label;
                                if (d.children && d.children.length > 0) {
                                    for (var sd of d.children) {
                                        if (sd.id == this.obj_as['DIT']) {
                                            this.obj_as['DN'] = sd.label;
                                            break;
                                        }
                                    }
                                }
                                break;
                            }
                        }

                        this.domainUrl = `https://${this.obj_as['DN']}/`;
                        this.domainUrl = this.validateURL(this.domainUrl);

                        if (this.obj_as.PT == 1) {
                            this.pageUrlAllow = true;
                            this.domainUrl += this.getLangDirectoryName(this.obj_as['L'], '/') + 'blog/' +  (this.obj_as['PURL'] ? this.obj_as['PURL'] : '');
                        }

                        return this.domainUrl;
                    }
                    else if (this.obj_as['DIT'] != null && this.obj_as['PGTS'] != null) {
                        var domain = this.obj_as['DIT'].split("-");
                        var mainDomain = domain[0] + "-0";
                        for (var d of this.dd_do) {
                            if (d.id == mainDomain) {
                                this.obj_as['DN'] = d.label;
                                if (d.children && d.children.length > 0) {
                                    for (var sd of d.children) {
                                        if (sd.id == this.obj_as['DIT']) {
                                            this.obj_as['DN'] = sd.label;
                                            break;
                                        }
                                    }
                                }
                                break;
                            }
                        }

                        this.domainUrl = `https://${this.obj_as['DN']}/`;
                        this.domainUrl = this.validateURL(this.domainUrl);

                        if (this.obj_as.PT == 0) {
                            this.pageUrlAllow = true;
                            this.obj_as['PURL'] = '';

                            for (var pt of this.dd_spt) {
                                if (pt.id == this.obj_as['PGTS']) {
                                    var isLobby = true;
                                    for (var i = 0; i < this.excludeId.length; i++) {
                                        if (this.excludeId[i] == pt.id) {
                                            isLobby = false;
                                        }
                                    }

                                    if (isLobby) {
                                        this.obj_as['PURL'] += this.generatePageUrl(pt.label)
                                        this.domainUrl += this.obj_as['PURL'];
                                    }
                                    else if (!isLobby && pt.id == 103) {
                                        if (this.obj_as.GPRVD != null) {
                                            if (this.dd_gp != null) {
                                                for (var prvd of this.dd_gp) {
                                                    if (prvd.id == this.obj_as['GPRVD']) {
                                                        this.obj_as['PURL'] = this.generateGP(prvd.extraCat) + '/' + this.generateGP(prvd.extra);
                                                    }
                                                }
                                            }
                                        }
                                        this.domainUrl += this.obj_as['PURL'];
                                    }
                                    else if (!isLobby && pt.id != 0) {
                                        this.obj_as['PURL'] = this.generatePageUrl(pt.label2)
                                        this.obj_as['PURL'] += '/' + pt.label3
                                        this.domainUrl += this.obj_as['PURL'];
                                    }

                                }
                            }

                            for (var pt of this.dd_spt) {
                                if (pt.id == this.obj_as['PGTS']) {
                                    if(pt.id == 109 || pt.id == 110 || pt.id == 0){
                                        this.obj_as['PURL'] = `https://${this.obj_as['DN']}/${(pt.label.trim()).split(' ').join('-')}`;
                                    }else{
                                        this.obj_as['PURL'] = `https://${this.obj_as['DN']}/${this.getLangDirectoryName(this.obj_as['L'], '/')}${(pt.label.trim()).split(' ').join('-')}`;
                                    }
                                    this.obj_as['PURL'] = this.validateURL(this.obj_as['PURL']);
                                }
                            }
                        }
                        else if (this.obj_as.PT == 2) {
                            this.pageUrlAllow = true;
                            for (var pt of this.dd_stapt) {
                                if (pt.id == this.obj_as['PGTS']) {
                                    this.obj_as['PURL'] = this.generatePageUrl(pt.label);
                                    if (this.obj_as.PGTS == 2) {
                                        this.domainUrl += this.getLangDirectoryName(this.obj_as['L'], '/') + 'general/' +  this.obj_as['PURL'] + (this.obj_as['BT'] ? '/' + this.obj_as['BT'] : '');
                                    }
                                    else if (this.obj_as.PGTS == 5) {
                                        this.domainUrl += + this.getLangDirectoryName(this.obj_as['L'], '/') + this.obj_as['PURL'] + '/' ;
                                    }
                                    else {
                                        this.domainUrl += this.getLangDirectoryName(this.obj_as['L'], '/') + 'general/' +  this.obj_as['PURL'];
                                    }
                                }
                            }
                        }
                        else {
                            this.pageUrlAllow = true;
                            this.domainUrl += this.getLangDirectoryName(this.obj_as['L'], '/') + 'blog/' +  (this.obj_as['PURL'] ? this.obj_as['PURL'] : '');
                        }

                        return this.domainUrl;
                    }

                    return ``;
                }
            }
        },
        methods: {
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[3].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[3].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[3].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[3].FV.endDate = "";
                    }
                }
            },
            formatURL: function (dt) {
                var result = '';
                var url = '';
                if (dt) {
                    if (dt.PT == 0) {
                        var pgt = -1;
                        var lbl2 = "";
                        var lbl3 = "";
                        var lbl4 = "";
                        for (var pt of this.dd_spt) {
                            if (pt.label == dt.PGT) {
                                pgt = pt.id;
                                if (pt.id != 0 && pt.id != 103) {
                                    lbl2 = pt.label2
                                    lbl3 = pt.label3
                                }
                                else if (pt.id == 103) {
                                    lbl2 = pt.label2
                                    lbl3 = pt.label3
                                    lbl4 = pt.label4
                                }
                                break;
                            }
                        }

                        var isLobby = true;
                        for (var i = 0; i < this.excludeId.length; i++) {
                            if (this.excludeId[i] == pgt) {
                                isLobby = false;
                            }
                        }

                        if (isLobby) {
                            url = `https://${dt.DN}/` + dt.PURL;
                            url = this.validateURL(url);
                        }
                        else if (pgt == 0) {
                            url = `https://${dt.DN}/`;
                            url = this.validateURL(url);
                        } else if (pgt == 103) {
                            var category = "";
                            var provider = "";
                            if (this.dd_gameprovider != null && dt.PRVD != 0) {
                                for (var prvd of this.dd_gameprovider) {
                                    if (prvd.id == dt.PRVD) {
                                        provider = prvd.extra;
                                        category = prvd.extraCat;
                                    }
                                }
                            }

                            url = `https://${dt.DN}/` + this.generateGP(category) + '/' + this.generateGP(provider);
                            url = this.validateURL(url);

                        } else {
                            if(pgt == 100 || pgt == 104 || pgt == 105 || pgt == 106 || pgt == 107 || pgt == 108){
                                url = `https://${dt.DN}/${this.getLangDirectoryName(dt.L)}/` + lbl2 + '/' + lbl3;
                            }else{
                                url = `https://${dt.DN}/` + lbl2 + '/' + lbl3;
                            }
                            url = this.validateURL(url);
                        }
                    }
                    if (dt.PT == 1) {
                        url = `https://${dt.DN}/${this.getLangDirectoryName(dt.L, "/")}blog/` + dt.PURL;
                        url = this.validateURL(url);
                    }
                    else if (dt.PT == 2) {
                        var pgts = 0;
                        for (var pt of this.dd_stapt) {
                            if (pt.label == dt.PGT) {
                                pgts = pt.id;
                            }
                        }

                        if (pgts == 2) {
                            url = `https://${dt.DN}/${this.getLangDirectoryName(dt.L, "/")}general/` + dt.PURL + (dt.BT ? '/' + dt.BT : '');
                            url = this.validateURL(url);
                        }
                        else if (pgts == 5) {
                            url = `https://${dt.DN}/${this.getLangDirectoryName(dt.L, "/")}blog/` ;
                            url = this.validateURL(url);
                        }
                        else {
                            url = `https://${dt.DN}/${this.getLangDirectoryName(dt.L, "/")}general/` + dt.PURL;
                            url = this.validateURL(url);
                        }
                    }
                }
                if (url) {
                    result = '<a href="' + url + '" target="_blank">' + this.substrContent(url, 30) + '</a>';
                }

                return result;
            },
            getLangDirectoryName: function (lang, suffix) {
                if (lang) {
                    lang = this.generatePageUrl(lang) + (suffix ? suffix : '');
                }

                return lang;
            },
            generateGP(url) {
                if (url) {
                    url = url.trim().toLowerCase();
                    url = url.replace(/ /gi, "-");
                    url = url.replace(/_/gi, "-");
                }
                return url;
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('S', 'MS', type);
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
                this.obj_as['AGIT'] = null;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getSEOList();
            },
            newSearch() {
                if (!this.bool_isAMV && this.int_Page == this.int_IC) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getSEOList();
                }
                if (!this.bool_isAMV && this.int_Page != this.int_IC) {
                    this.ctrPage(this.int_Page);
                }
            },
            getLangauge() {
                var that = this;
                this.getDataApi(`/api/dd/lang/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_langfs = d.dropdownlist
                        }

                    });
            },
            getPageType() {
                var that = this;
                this.getDataApi(`/api/dd/gameCat`,
                    function (d, s) {
                        if (s) {
                            that.dd_spt = d.dropdownlist;
                            that.dd_spt.push({ id: '0', label: 'Home' })
                            that.dd_spt.push({ id: '100', label: 'Promotion', label2: 'promotion-list', label3: '' })
                            //that.dd_spt.push({id:'101',label:'UserProfile',label2:'user',label3:'profile'})
                            that.dd_spt.push({ id: '102', label: 'Top 5 Games', label2: 'top-5-games', label3: '' })
                            that.dd_spt.push({ id: '103', label: 'Game Lobby', label2: 'game', label3: 'globby', label4: 'hall' })
                            that.dd_spt.push({ id: '104', label: 'Info Center', label2: 'info', label3: '' })
                            that.dd_spt.push({ id: '105', label: 'Search Game', label2: 'search-game', label3: '' })
                            that.dd_spt.push({ id: '106', label: 'Latest News', label2: 'news', label3: 'list' })
                            that.dd_spt.push({ id: '107', label: 'Daily Lucky Spin', label2: 'dailyluckyspin', label3: '' })
                            that.dd_spt.push({ id: '108', label: 'Tournament', label2: 'tournament-list', label3: '' })
                            that.dd_spt.push({ id: '109', label: 'Register Successful', label2: 'register-success', label3: '' })
                            that.dd_spt.push({ id: '110', label: 'Deposit Successful', label2: 'deposit-success', label3: '' })
                        }
                    });
            },
            getMetaRobot() {
                //this.dd_mr = consMetaRobot;
                this.dd_mr = [{ id: 'No Index', label: this.getLanguage['SEO']['NI'] }, { id: 'Index', label: this.getLanguage['SEO']['ID'] }, { id: 'Follow', label: this.getLanguage['SEO']['FL'] }, { id: 'No Follow', label: this.getLanguage['SEO']['NFL'] }, { id: 'No Image Index', label: this.getLanguage['SEO']['NIID'] }, { id: 'None', label: this.getLanguage['SEO']['N'] }, { id: 'No Archive', label: this.getLanguage['SEO']['NAC'] }, { id: 'No Cache', label: this.getLanguage['SEO']['NC'] }, { id: 'No Snippet', label: this.getLanguage['SEO']['NSP'] }];
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroupfs.length > 0) {
                                that.dd_agentgroupfs.forEach(that.disableAgentGroupParent);
                            }

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }

                            that.dd_exclude_agentgroup = that.deepClone(d.dropdownlist);
                        }
                    });
            },
            getSubAgentGroup(value, isFirstLoad = false) {
                var that = this;
                this.getDataApi(`/api/dd/subbrand/0/0/${value}/0/1`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.dd_DefaultSubBrand = that.deepClone(d.dropdownlist);

                            if (isFirstLoad) {
                                that.str_FV[6].FV = that.dd_DefaultSubBrand[0].id;
                                that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                                that.getSEOList();
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");

                if (agi[0] != "3" && agi[0] != "4") {
                    item.isDisabled = true;
                }

                if (this.getUserInfo.AT == 0 && agi[0] == "0") {
                    item.isDisabled = false;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            PageTypeChange(value) {
                this.obj_as['PGTS'] = null;
                this.obj_as['RS'] = true;
                this.obj_as['GPRVD'] = null;
                this.dd_gp = [];

                this.pageUrlAllow = value != 99;
            },
            loadProviderOptions({ action, callback, instanceId }) {
                var that = this;

                if (!this.obj_as.AGIT || this.obj_as.PGTS != 103 || !this.obj_as.DI) {
                    callback(this.getLanguage['MEM']['PSAA']);
                }
                else {

                    var agi = this.obj_as.AGIT.split("-")[1];

                    this.getDataApi(`/api/dd/gameP/${agi}/${this.obj_as.DI}/0`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_gp = d.dropdownlist;
                                for (var i = 0; i < that.dd_gp.length; i++) {
                                    that.dd_gp[i].label = that.renderProviderName(that.dd_gp[i].label2);
                                }
                            }
                            else {
                                that.dd_gp = null;
                            }

                            callback();
                        });
                }
            },
            ClearDD(value) { //here clear option and select
                this.dd_gp = null;
                this.obj_as.GPRVD = null;
            },
            ClearBT(value) { //here clear faq title
                this.obj_as.BT = null;
            },
            HTMLEditorTextChange(value) {
                if (value.level.fragments && value.level.fragments.length > 0) {
                    var tempContent = '';
                    for (var i = 0; i < value.level.fragments.length; i++) {
                        tempContent += value.level.fragments[i];
                    }

                    this.editorText = tempContent;
                }
                else {
                    this.editorText = value.level.content;
                }
            },
            AgentGroupChangefs(value) {
                this.dd_dofs = [];
                this.str_FV[6].FV = null;
                if (value != undefined) {
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                    }

                    this.getDataApi(`/api/dd/dadn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_dofs = d.dropdownlist
                                that.str_FV[1].FV = agi;
                                that.str_FV[6].FV = null;
                            }
                        });
                }
                else {
                    this.str_FV[1].FV = null;
                    this.str_FV[6].FV = null;
                    this.dd_dofs = [];
                }
                this.str_FV[2].FV = null;
            },
            SubAgentGroupChangefs(value) {
                this.dd_dofs = [];
                if (value != undefined) {
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value;
                    }
                    this.getDataApi(`/api/dd/dadn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_dofs = d.dropdownlist
                                that.str_FV[6].FV = agi;
                            }
                        });
                }
                else {
                    this.dd_dofs = [];
                }
                this.str_FV[2].FV = null;
            },
            ProviderChange(value) {
                if (this.obj_as['I'] == 0) {
                    if (this.dd_gp != null) {
                        for (var prvd of this.dd_gp) {
                            if (prvd.id == this.obj_as['GPRVD']) {
                                this.obj_as['MT'] = this.renderProviderName(prvd.label);
                            }
                        }
                    }
                }
            },
            //DomainChange(value) {
            //    if (this.obj_as['I'] == 0) {
            //        this.obj_as['PGTS'] = null;
            //        this.obj_as['GPRD'] = null;
            //        this.dd_gp = [];
            //    }
            //},
            AgentGroupChange(value) {
                this.dd_do = [];
                if (this.obj_as['I'] == 0) {
                    this.obj_as['DIT'] = null;
                    this.obj_as['PGTS'] = null;
                    this.obj_as['GPRD'] = null;
                    this.dd_gp = [];
                    this.dd_lang = [];
                }
                var that = this;
                var agi = 0;
                this.obj_as['SAGAGI'] = null;

                if (value != "") {
                    agi = value.split("-")[1];                    
                    this.obj_as.AT = value.split("-")[0];                    
                }

                if (this.obj_as.AT == 0) {
                    this.getDataApi(`/api/dd/lang/0`, function (d, s) {
                        if (s) {
                            that.dd_lang = d.dropdownlist;
                            that.obj_as.SAGAGI = null;
                        }
                    });
                } else {
                    //this.getDataApi(`/api/dd/dn/` + agi,
                    //    function (d, s) {
                    //        if (s) {
                    //            that.dd_do = d.dropdownlist;
                    //        }
                    //    });
                    this.getDataApi(`/api/dd/dadn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_do = d.dropdownlist
                            }
                        });


                    that.sensBtn = ((that.isSENS == 1 && agi != that.curAGI) ? true : false);
                }                

            },
            SubAgentGroupChange(value) {
                this.dd_do = [];
                if (this.obj_as['I'] == 0) {
                    this.obj_as['DIT'] = null;
                    this.obj_as['PGTS'] = null;
                    this.obj_as['GPRD'] = null;
                    this.dd_gp = [];
                    this.dd_lang = [];
                }
                var that = this;
                var agi = 0;

                if (value != "") {
                    agi = value;
                }

                if (this.obj_as.AT == 0) {
                    this.getDataApi(`/api/dd/lang/0`, function (d, s) {
                        if (s) {
                            that.dd_lang = d.dropdownlist;
                        }
                    });
                } else {
                    //this.getDataApi(`/api/dd/dn/` + agi,
                    //    function (d, s) {
                    //        if (s) {
                    //            that.dd_do = d.dropdownlist;
                    //        }
                    //    });
                    this.getDataApi(`/api/dd/dadn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_do = d.dropdownlist
                            }
                        });
                }
            },
            DomainChange(value) {
                var that = this;
                if (value) {
                    var domain = value.split("-");
                    that.obj_as.DI = domain[0];
                    //if (that.obj_as.AT == 4) {
                    if (that.obj_as.SAGAGI) {
                        this.getDataApi(`/api/dd/dlang-sub/` + domain[0], function (d, s) {
                            if (s) {
                                that.dd_lang = d.dropdownlist;
                            }
                        });
                    } else {
                        this.getDataApi(`/api/dd/dlang/` + domain[0], function (d, s) {
                            if (s) {
                                that.dd_lang = d.dropdownlist;
                            }
                        });
                    }
                }
                else {
                    that.dd_lang = [];
                    that.obj_as.DI = null;
                }
                if (that.obj_as.I == 0) {
                    that.obj_as.L = null;
                    that.obj_as['PGTS'] = null;
                    that.obj_as['GPRD'] = null;
                    that.dd_gp = [];
                }
            },
            //DomainChangefs(value) {
            //    var that = this;
            //    if (value && value > 0) {
            //        this.getDataApi(`/api/dd/dlang/` + value, function (d, s) {
            //            if (s) {
            //                that.dd_langfs = d.dropdownlist;
            //            }
            //        });
            //    }
            //    else {
            //        that.dd_langfs = [];
            //    }
            //    that.str_FV[4].FV = [];
            //},
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;

                if (this.obj_as['AGIT'] && this.bool_isAMV) {
                    var agentList = this.obj_as['AGIT'].split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.str_FV[1].FV && !this.bool_isAMV) {
                    var agentList = this.str_FV[1].FV.split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else {
                    this.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}/0/1`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }
            },
            getSEOList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV && i != 1 && i != 6) {

                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                var split = this.str_FV[i].FV[x].split("-");

                                if (split.length == 2) {
                                    temp_ += split[1];
                                }
                                else {
                                    temp_ += split[0];
                                }
                            }
                            path += ("&f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else if (this.str_FV[i].F == 'CTS' && this.str_FV[i].FV != '') {
                            if (this.str_FV[i].FV.startDate != "") {
                                var cts_from = this.parseDateToJsonString(this.str_FV[i].FV.startDate);
                                path += "&f[CTS_from]=" + cts_from;
                            }
                            if (this.str_FV[i].FV.endDate != "") {
                                var cts_to = this.parseDateToJsonString(this.str_FV[i].FV.endDate);
                                path += "&f[CTS_to]=" + cts_to;
                            }
                        }
                        else if (this.str_FV[i].F == 'DIT') {
                            var domain = this.str_FV[i].FV.split("-");
                            path += "&f[DI]=" + domain[0] + "&f[DAI]=" + domain[1];
                        }
                        else {
                            path += ("&f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };

                if (this.str_FV[6].FV) {
                    path += "&f[AGI]=" + this.str_FV[6].FV;
                } else if (this.str_FV[1].FV) {
                    path += "&f[AGI]=" + this.str_FV[1].FV;
                }

                this.getDataApi(`/api/seo/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setSEOList(d.D);
                            that.resizeTableHead();
                        }
                    });
            },
            setSEOList(data) {
                this.arry_sl = data.Items;
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_TI = data.TotalItems;
            },
            setSEO(data) {
                this.editorText = data.AC;

                this.obj_as = Object.assign(this.obj_as, data);

                if (this.obj_as['PRVD'] == 0) {
                    this.obj_as['GPRVD'] = null
                } else {
                    this.obj_as['GPRVD'] = this.obj_as['PRVD'];
                }

                if (this.obj_as['RS'] == 2 && this.obj_as['PT'] == 2) {
                    this.obj_as['RS'] = 1
                }

                var metaRobot = data.MR;
                var metaRobotArr = metaRobot.split(',');
                this.obj_as["MetaRobot"] = metaRobotArr;
                this.obj_as['BT'] = data.BT;

                if (this.obj_as.PT == 0) {
                    for (var pt of this.dd_spt) {
                        if (pt.label == this.obj_as['PGT']) {
                            this.obj_as['PGTS'] = pt.id;
                        }
                    }
                }
                else if (this.obj_as.PT == 2) {
                    for (var pt of this.dd_stapt) {
                        if (pt.label == this.obj_as['PGT']) {
                            this.obj_as['PGTS'] = pt.id;
                        }
                    }
                }
                else if (this.obj_as.PT == 1) {
                    this.obj_as['PGTS'] = this.obj_as['PGT'];
                }

                this.pageUrlAllow = this.obj_as.PT == 0 || this.obj_as.PT == 1 || this.obj_as.PT == 2;

                if (this.obj_as.PGTS && this.obj_as.PGTS == 103) {
                    var that = this;
                    this.getDataApi(`/api/dd/gameP/${this.obj_as.AGI}/${this.obj_as.DI}/0`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_gp = d.dropdownlist;
                                for (var i = 0; i < that.dd_gp.length; i++) {
                                    that.dd_gp[i].label = that.renderProviderName(that.dd_gp[i].label2);
                                }
                            }
                            else {
                                that.dd_gp = null;
                            }
                        });
                }
                else {
                    this.dd_gp = null;
                }
                if (this.obj_as.EXCB != null && this.obj_as.EXCB.length > 0) {
                    this.arr_excludeBrand = this.obj_as.EXCB.split(',');
                }
                else {
                    this.arr_excludeBrand = null;
                }
                this.bool_isAMV = true;
            },
            getGameProvider() {
                var that = this;
                this.getDataApi(`/api/dd/gameP/0/0/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.dd_gameprovider = d.dropdownlist;
                            for (var i = 0; i < that.dd_gameprovider.length; i++) {
                                that.dd_gameprovider[i].label = that.renderProviderName(that.dd_gameprovider[i].label2);
                            }
                        }
                        else {
                            that.dd_gameprovider = null;
                        }
                    });
            },
            addSEO() {
                this.obj_as = {
                    I: 0,
                    RS: true,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    DN: null,
                    DI: null,
                    DIT: null,
                    DAI: null,
                    L: null,
                    PT: null,
                    PGT: null,
                    PGTS: null,
                    PURL: null,
                    PRVD: null,
                    GPRVD: null,
                    BT: null,
                    MT: null,
                    MK: null,
                    MR: [],
                    MetaRobot: null,
                    MD: null,
                    SD: null,
                    AC: "",
                    AGI: "",
                    SAGAGI: null,
                    AGIT: null,
                    HS: null,
                    FS: null,
                    AT: 3,
                    editorText: "",
                    PMIUT: false,
                    OI: "",
                    OT: null,
                    OD: null,
                    OTP: null
                };
                this.editorText = "";
                this.dd_do = [];
                this.bool_CV = false;
                this.bool_isAMV = true;
                this.NewPMIUFile = null;
                if (this.getUserInfo.AT === 4) {
                    this.getSubAgentGroup(0, true);
                }
                else {
                    this.dd_DefaultSubBrand = [];
                }

                if (this.dd_agentgroup[0].children == undefined) {
                    //var at = 0;
                    //at = this.dd_agentgroup[0].id.split("-")[0];
                    //if (at == 3 && this.dd_agentgroup.length < 2) {
                    this.obj_as.AGIT = this.dd_agentgroup[0].id;                    
                    this.AgentGroupChange(this.obj_as.AGIT);
                    //}
                }
            },
            ValidationErrMsg(value, langKey = "") {

                if (this.bool_CV) {
                    var validateObj = this.$v.obj_as[value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["SEO"][langKey]);
                    }
                }

            },
            saveSEO() {
                this.bool_CV = true;
                this.obj_as.AC = this.editorText;

                this.$v.obj_as.$touch();
                if (!this.$v.obj_as.$error) {

                    if (this.obj_as.AT == 0) {
                        this.obj_as['DI'] = 0;
                    }
                    if (this.NewPMIUFile != null) {
                        this.obj_as['FOI'] = this.NewPMIUFile;
                    }
                    else {
                        this.obj_as['FOI'] = null;
                    }
                    if (this.obj_as.MetaRobot != null && this.obj_as.MetaRobot.length > 0) {
                        this.obj_as.MR = this.obj_as.MetaRobot.join(',');
                    }

                    if (this.obj_as['RS'] && this.obj_as['PT'] == 2) {
                        this.obj_as['RS'] = 3;
                    }
                    else {
                        this.obj_as['RS'] = 2;
                    }

                    if (this.obj_as.AGIT != null && this.obj_as.AGIT.length > 0) {
                        var agi = this.obj_as.AGIT.split("-");
                        this.obj_as.AGI = agi[1];
                    }

                    if (this.obj_as.PT == 0) {
                        for (var pt of this.dd_spt) {
                            if (pt.id == this.obj_as['PGTS']) {
                                this.obj_as['PGT'] = pt.label;
                            }
                        }
                    }

                    if (this.obj_as.PT == 1) {
                        this.obj_as['PGT'] = this.obj_as['PGTS'];
                    }

                    if (this.obj_as.PT == 2) {
                        for (var pt of this.dd_stapt) {
                            if (pt.id == this.obj_as['PGTS']) {
                                this.obj_as['PGT'] = pt.label;
                            }
                        }
                    }

                    if (this.obj_as.DIT != null) {
                        var domain = this.obj_as.DIT.split("-");
                        this.obj_as.DI = domain[0];
                        this.obj_as.DAI = domain[1];
                    }
                    this.obj_as.PRVD = this.obj_as.GPRVD;

                    //when save, if got subagentid assign it into agentid
                    if (this.obj_as.SAGAGI) {
                        this.obj_as.AGI = this.obj_as.SAGAGI;
                    }
                    if (this.getUserInfo.AT > 0 || this.obj_as.AT > 0 || this.obj_as.PGTS != 2 && this.obj_as.PT != 2) {
                        this.obj_as.FD = false;
                    }
                    if (this.obj_as.FD && this.arr_excludeBrand != null && this.arr_excludeBrand.length > 0) {
                        this.obj_as.EXCB = this.arr_excludeBrand.join(',');
                    } else {
                        this.obj_as.EXCB = '';
                    }
                    var that = this;
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    this.postDataApiWithAttach(`/api/seo/s`, this.obj_as,
                        function (d, s) {

                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;

                            if (s) {
                                that.bool_isAMV = false;
                                that.NewPMIUFile = null;
                                that.getSEOList();

                            }
                        });
                } else {
                    //get the object for validating.
                    const validation = this.$v["obj_as"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            editSEO(id) {
                this.bool_fullLoading = true;
                var that = this;
                this.getSubAgentGroup(0);

                this.getDataApi(`/api/seo/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {

                            that.NewPMIUFile = null;
                            that.setSEO(d.D);
                            that.bool_isAMV = false;
                            if (that.obj_as.AGI != 18) {

                                var tempSAGAGI = that.obj_as.SAGAGI;  //keep sagagi because when AgentGroupChange will assign null
                                that.obj_as.AGIT = "3-" + that.obj_as.AAGI;
                                that.AgentGroupChange(that.obj_as.AGIT);
                                if (tempSAGAGI > 0) {
                                    that.SubAgentGroupChange(tempSAGAGI);
                                    that.obj_as.SAGAGI = tempSAGAGI;
                                } else {
                                    that.obj_as.SAGAGI = null;
                                }
                            }
                            else if (that.obj_as.AGI == 18) {
                                that.obj_as.AGIT = "0-" + that.obj_as.AGI;                                
                                that.AgentGroupChange(that.obj_as.AGIT);
                            }
                            if (that.obj_as['RS'] == 1) {
                                that.obj_as['RS'] = false;
                            }
                            else if (that.obj_as['RS'] == 3 || that.obj_as['RS'] == 2) {
                                that.obj_as['RS'] = true;
                            }
                            that.obj_as.DIT = that.obj_as.DI + "-" + that.obj_as.DAI;
                            that.DomainChange(that.obj_as.DIT);
                            that.bool_isAMV = true;

                        }
                    });
            },
            removeSEO(data) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: data.I,
                            uts: data.UTS,
                            di: data.DI,
                            dai: data.DAI,
                            AGI: data.AGI
                        };

                        this.postDataApi(`/api/seo/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getSEOList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            ConvertPageType(value, gamep) {
                var text = '';
                for (var i = 0; i < this.dd_pt.length; i++) {
                    if (this.dd_pt[i].id == value) {
                        text = this.dd_pt[i].label;
                    }
                }
                return text;
            },
            ConvertPageTitle(gamep) {
                var text = '';
                if (this.dd_gameprovider != null && gamep != 0) {
                    for (var prvd of this.dd_gameprovider) {
                        if (prvd.id == gamep) {
                            text = '- ' + this.renderProviderName(prvd.label) + text;
                        }
                    }
                }
                return text;
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
                this.getSEOList();
            },
            onPMIUFileSelected(event) {
                this.obj_as['OI'] = "";
                this.NewPMIUFile = this.validateFile(event);
            },
            setFlag(languageCode) {
                return this.mapLanguageFlag(languageCode);
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            clearDateRangeFilter() {
                this.str_FV[3].FV = {
                    startDate: "",
                    endDate: ""
                };
            },
            generatePageUrl(url) {
                if (url) {
                    url = url.trim().toLowerCase();
                    url = url.replace(/ /gi, "-");
                    url = url.replace(/[^a-zA-Z0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF0-9-_]/g, '');
                }

                return url;
            },
            verifyPageUrl(event) {
                this.obj_as.PURL = event;
                this.obj_as['PURL'] = this.generatePageUrl(this.obj_as['PURL']);

            },
            pageTitleChanged(event) {
                this.obj_as.PGTS = event;
                this.obj_as['PURL'] = this.generatePageUrl(this.obj_as['PGTS']);
                this.obj_as['MT'] = this.obj_as['PGTS'];
            },
            pageBTitleChanged(event) {
                this.obj_as['BT'] = this.generatePageUrl(event);
            },
            TextValueChange(type, event) {
                if (type == "MD") {
                    this.obj_as.MD = event.target.value;
                }
                else if (type == "SD") {
                    this.obj_as.SD = event.target.value;
                }
                else if (type == "HS") {
                    this.obj_as.HS = event.target.value;
                }
                else if (type == "FS") {
                    this.obj_as.FS = event.target.value;
                }
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            getPType() {
                this.dd_pt = [{ id: '0', label: this.getLanguage['SEO']['SP'] }, { id: '1', label: this.getLanguage['SEO']['CP'] }, { id: '2', label: this.getLanguage['SEO']['STP'] }];
            }
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getSEOList();
                this.getPType();
                this.getMetaRobot();
            },
        },
    }
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/SideMenu/Marketing/SEOS.vue